<template>
  <div v-if="lists" class="table">
    <div class="grid-table">
      <SummaryTableHeader />

      <template>
        <SummaryListRow
          v-for="(list, i) in lists"
          :key="list.list.id"
          :currency="currency"
          v-bind="{
            list: {
              order: list.list.order,
              title: list.list.title,
              id: list.list.id,
            },
            one: list.labour,
            two: list.materials,
            three: list.tools,
            total: list.total,
            index: i + 1,
          }"
        />
        <SummaryTotal
          v-bind="{
            one: parseFloat(summary.one) + taxes_total.labour,
            two: parseFloat(summary.two) + taxes_total.materials,
            three: parseFloat(summary.three) + taxes_total.tools,
            total: parseFloat(summary.total) + taxes_total.total,
          }"
          :label="$t('Total price')"
          :currency="currency"
        />
      </template>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import projectListsTotalQuery from '@/gql/summary/project-lists-total.graphql';
  import summaryQuery from '@/gql/summary/summary.graphql';
  import totalTaxesQuery from '@/gql/summary/total-with-taxes.graphql';

  import SummaryTableHeader from '@/components/project/summary/Header';
  import SummaryListRow from '@/components/project/summary/Row';
  import SummaryTotal from '@/components/project/summary/Total';

  export default {
    name: 'SummaryTable',
    components: { SummaryTotal, SummaryListRow, SummaryTableHeader },
    apollo: {
      lists() {
        return {
          query: projectListsTotalQuery,
          fetchPolicy: 'no-cache',
          variables() {
            return {
              id: this.$route.params.id,
            };
          },
          update(data) {
            if (data.costs) {
              this.subtotal = data.subtotal.aggregate.sum;
              this.additional = data.additional;
              this.taxes = data.tax;
              this.project = data.projects[0];
              this.currency = data.projects[0]?.currency;

              data.id = new Date().toString();
              return data.costs;
            }
            return {};
          },
        };
      },

      $subscribe: {
        summary: {
          query: summaryQuery,
          variables() {
            return {
              id: this.$route.params.id,
              version: this.$route.params.version,
            };
          },
          result({ data }) {
            if (data.total) this.summary = data.total[0] || {};
          },
        },

        taxes_total: {
          query: totalTaxesQuery,
          variables() {
            return {
              id: this.$route.params.id,
              version: this.$route.params.version,
            };
          },
          result({ data }) {
            if (data.taxes_total) this.taxes_total = data.taxes_total.aggregate.sum || {};
          },
        },
      },
    },
    data() {
      return {
        project: {},
        summary: {},
        taxes_total: {},
        subtotal: [],
        additional: [],
        taxes: [],
        currency: '',
      };
    },
    computed: {
      ...mapState({
        projectUpdate: (state) => state.global.projectUpdate,
        // historyUpdate: (state) => state.history.updated,
      }),
    },
    watch: {
      projectUpdate: async function () {
        await this.$apollo.queries.lists.refetch();
        await this.$store.dispatch('global/changeProjectUpdate', null);
      },
      // historyUpdate: function (val) {
      //   if (val.type === 'tax' || val.type === 'custom_additional_summary_cost') {
      //     this.$apollo.queries.lists.refetch();
      //   }
      // },
    },
  };
</script>
